module.exports = __webpack_public_path__ + "static/img/active_mobile1.4d181888.jpg";